/******************************************************************/
/*****Initially Created By Fahad Akbar(fahadakbar24@gmail.com)*****/
/******************************************************************/
const isSelected = object => object.isSelected;
const isAnyObjectSelected = objectArray => objectArray.some(isSelected);

const countSelectedObjects = (allObjects) => {
  return getSelectedObjects(allObjects).length;
};

const getSelectedObjects = (allObjects) => {
  return _.filter(allObjects, object => {
    return isSelected(object);
  });
};

const getSelectedObjectsProperty = (allObjects, property) => {
  return new Promise( (resolve, reject) => {
    resolve(getSelectedObjects(allObjects).map(object => object[property]));
  });
};

const setPropertyForAllObjects = (allObjects, property, value) => {
  if( _.isEmpty(allObjects) )
      return;
  else if( !_.isArray(allObjects) )
      allObjects = new Array(allObjects);

allObjects.forEach(object => object[property] = value);
};

const changeSelectedForAllObjects = (allObjects, value) => {
  setPropertyForAllObjects(allObjects, 'isSelected', value);
};

const getDefaultListForAssignedAdminDropdown = (listOfAdmins) => {
  return [{
    name: "Select None",
    ticked: true,
    value: 0
  }].concat(
    listOfAdmins.map((admin) => {
      return {
        name: admin.first_Name + " " + admin.last_Name,
        email: admin.email,
        user_ID: admin.user_ID,
        ticked: false,
        value: admin.user_ID
      };
    })
  );
};

// Converts a CSV into an ARRAY
const splitStringIntoArray = (string, splitter) => {
  return (!string) ?string :string.split(splitter);
};

const isSignUpPage = (url = '') => !!url.match(url.match(/^\/sign-?up.*/));
const isResetPasswordPage = (url = '') => !!url.match(url.match(/^\/reset-?[pP]assword.*/));

export {
  countSelectedObjects,
  getSelectedObjects,
  getSelectedObjectsProperty,
  changeSelectedForAllObjects,
  setPropertyForAllObjects,
  getDefaultListForAssignedAdminDropdown,
  isSelected,
  isAnyObjectSelected,
  isSignUpPage,
  isResetPasswordPage,
  splitStringIntoArray
}



// WEBPACK FOOTER //
// ./scripts/shared/utils/common.js